import gsap from 'gsap';
import {
  GALLERY_SELECTOR,
  MEDIA_SELECTOR,
  THUMBNAIL_SELECTOR,
  LEFT_ARROW_SELECTOR,
  RIGHT_ARROW_SELECTOR,
  THUMBNAIL_IMAGE_SELECTOR
} from '../../classnames/above-the-fold-gallery';

import Carousel from '../../design-system/carousel/with-arrows';

const SCALE_FACTOR = 0.1;

export default class Gallery {
  selector = `${GALLERY_SELECTOR}`;

  initGalleries = (galleries, selector) => {
    [...galleries].forEach((gallery) => {
      const carousel = new Carousel({
        containerSelector: `${selector}[data-product-id="${gallery.dataset.productId}"]`,
        elementSelector: MEDIA_SELECTOR,
        previousSelector: LEFT_ARROW_SELECTOR,
        nextSelector: RIGHT_ARROW_SELECTOR,
        thumbnailSelector: THUMBNAIL_SELECTOR
      });

      carousel.initializeEventListeners();
    });
  };

  handleMouseover = ({ currentTarget }) => {
    gsap.to(currentTarget, { scale: 1 + SCALE_FACTOR });
  };

  handleMouseout = ({ currentTarget }) => {
    gsap.to(currentTarget, { scale: 1 - SCALE_FACTOR });
  };

  initialize = () => {
    const galleries = document.querySelectorAll(this.selector);

    this.initGalleries(galleries, this.selector);

    const thumbnailImages = document.getElementsByClassName(THUMBNAIL_IMAGE_SELECTOR);

    [...thumbnailImages].forEach((image) => {
      image.addEventListener('mouseover', this.handleMouseover);
      image.addEventListener('mouseout', this.handleMouseout);
    });
  };
}
